<template lang="pug">
  v-card(flat @click="$emit('selected', item)")
    v-card-text
      v-row(no-gutters)
        v-col(cols="9")
          div.s1.basic800--text {{ item.title }}
          div.c1.basic600--text {{ displayReceiptId }} &middot; {{ displayDate }} &middot; {{ item.payment_method }}
        v-col.text-right
          div.p1(:class="displaySymbol === '+' ? 'success500--text': 'basic700--text'") {{ displaySymbol }} {{ item.amount | displayPrice($currency) }}
    v-divider.basic300(v-if="index !== totalItems")
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'CreditHistoryItemDetails',
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    totalItems: {
      type: Number,
      required: true
    }
  },
  computed: {
    displayReceiptId() {
      return `#${DateTime.fromISO(this.item.created).toFormat('yyMMdd')}-${this.item.ref}`
    },
    displayDate() {
      return DateTime.fromISO(this.item.created).toFormat('dd MMM')
    },
    displaySymbol() {
      return this.item.type === 'Wallet' ? '+' : '-'
    }
  }
}
</script>

<style scoped>
</style>